export default {
  // Favorites
  SET_FAVORITES_SORT_AND_FILTER: 'SET_FAVORITES_SORT_AND_FILTER',
  // SET_FAVORITES_FILTER_DATA: 'SET_FAVORITES_FILTER_DATA',
}
